// extracted by mini-css-extract-plugin
export default {"row":"styles_row__nmno0","w5":"styles_w5__5U94Z","w10":"styles_w10__bDavJ","w15":"styles_w15__9wOm7","w20":"styles_w20__9+moz"};